import React from 'react';

import {
  CommentInputSkeleton,
  CommentViewSideCommentsSkeleton,
  TextSkeleton,
} from '@pelando/components';

import { useTranslation } from '@/presentation/hooks/useTranslation';
import { DealTextSmallSkeleton } from '@/presentation/pages/public/Deal/components/DealInformationSection/style';
import { isIncentiveFirstComment } from '@/presentation/services/featureFlags';
import {
  CommentContainerSkeleton,
  CommentSideContainerSkeleton,
  SectionTitleSkeleton,
  SkeletonCommentSideHeaderWrapper,
  SkeletonDivider,
  SkeletonInputCommentSideWrapper,
  SkeletonInputWrapper,
  SkeletonTitleWrapper,
} from './style';

export const CommentsListSkeleton = () => (
  <div>
    <SkeletonInputWrapper>
      <SectionTitleSkeleton width="200px" />
    </SkeletonInputWrapper>
    <SkeletonInputWrapper>
      <TextSkeleton width="100px" />
    </SkeletonInputWrapper>
    <div>
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
      <CommentViewSideCommentsSkeleton />
    </div>
    <SkeletonInputWrapper>
      <TextSkeleton width="100px" />
    </SkeletonInputWrapper>
  </div>
);

export const CommentsSkeleton = () => {
  const { t } = useTranslation('deal');
  const commentSuggestionEnabled = isIncentiveFirstComment();
  return (
    <CommentContainerSkeleton
      aria-label={t('comment-skeleton-aria-label')}
      animate
    >
      <SkeletonInputWrapper>
        <CommentInputSkeleton
          commentSuggestionEnabled={commentSuggestionEnabled}
        />
      </SkeletonInputWrapper>
      <SkeletonDivider />
      <SkeletonTitleWrapper>
        <SectionTitleSkeleton width="200px" />
      </SkeletonTitleWrapper>
      <div>
        <CommentViewSideCommentsSkeleton />
        <CommentViewSideCommentsSkeleton />
      </div>
      <SkeletonDivider />
      <CommentsListSkeleton />
    </CommentContainerSkeleton>
  );
};

export const CommentsListFetchMoreSkeleton = () => (
  <div>
    {Array.from(Array(5).keys()).map((key) => (
      <CommentViewSideCommentsSkeleton key={key} />
    ))}
  </div>
);

export const CommentsSideSkeleton = () => {
  const commentSuggestionEnabled = isIncentiveFirstComment();
  return (
    <CommentSideContainerSkeleton>
      <div style={{ width: '100%' }}>
        <SkeletonCommentSideHeaderWrapper>
          <DealTextSmallSkeleton width="40%" />
          <DealTextSmallSkeleton width="20%" />
        </SkeletonCommentSideHeaderWrapper>

        <div>
          <CommentViewSideCommentsSkeleton />
          <CommentViewSideCommentsSkeleton />
          <CommentViewSideCommentsSkeleton />
          <CommentViewSideCommentsSkeleton />
        </div>

        <SkeletonInputCommentSideWrapper>
          <CommentInputSkeleton
            commentSuggestionEnabled={commentSuggestionEnabled}
          />
        </SkeletonInputCommentSideWrapper>
      </div>
    </CommentSideContainerSkeleton>
  );
};
